export default __webpack_public_path__ + "static/media/india_solar.b0253024.png";